/**
 * @generated SignedSource<<16ced8780c1aed67f62b96be3c1d30fb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperCardFragment$data = {
  readonly abstract: string;
  readonly announcedOn: any;
  readonly arxivId: string | null | undefined;
  readonly authors: ReadonlyArray<string>;
  readonly citedByCount: number | null | undefined;
  readonly openalexId: string | null | undefined;
  readonly primaryCategory: string | null | undefined;
  readonly title: string;
  readonly venue: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaperBookmarkButtonFragment">;
  readonly " $fragmentType": "PaperCardFragment";
};
export type PaperCardFragment$key = {
  readonly " $data"?: PaperCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaperCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaperCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arxivId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openalexId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "abstract",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authors",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCategory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "venue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "citedByCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "announcedOn",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaperBookmarkButtonFragment"
    }
  ],
  "type": "Paper",
  "abstractKey": null
};

(node as any).hash = "84381634fea257e869efced83730f37a";

export default node;
